import {FiPlus, FiSearch} from "react-icons/fi";
import {Link} from "react-router";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {TableEmptyStateCta} from "@/components/table/subComponents/TableEmptyStateCta/TableEmptyStateCta.tsx";

export const StatusPagesEmptyList = ({variant, colSpan}: {variant: "filter" | "empty"; colSpan: number}) => {
  if (variant === "filter") {
    return (
      <tr>
        <td colSpan={colSpan}>
          <div className="p-4 w-100 d-flex flex-column align-items-center justify-content-between">
            <Icon icon={FiSearch} size="core" className="pulse-color-gray-500 mb-2" />
            <div>
              <span className="pulseTextBodySmall pulse-color-gray-700">
                No Status Pages found matching the filter(s) above.
              </span>
            </div>
          </div>
        </td>
      </tr>
    );
  }

  return (
    <TableEmptyStateCta
      title="You do not have any Status Pages."
      cta={
        <Button as={Link} to="/statuspages/create" variant="secondary">
          <Icon icon={FiPlus} /> Create Status Page
        </Button>
      }
      colSpan={colSpan}
    />
  );
};
